export const STORAGE_PREFIX = 'SKYLINE_V3_';
export const EXPORT_PREFIX = 'SKYLINE_V3_SETTINGS_';
export const CSS_VARS_DOM_ID = 'skyline-css-vars';
export const CUSTOM_CSS_DOM_ID = 'skyline-custom-css';
